import { useState } from "react";
import { useLicenseDetails } from "../../contexts/licenseDetails";
import LicenseService from "../../services/LicensesService";
import Button from "../Button/Button";
import { UnitSelector } from "../UnitSelector/UnitSelector";
import {
   getZodFieldErrors,
   licenseAllocationSchema,
} from "../../validations/license-subpages.schema";

export function LicenseAllocatePage({ license }) {
   const { setCurrentSubTab, setLicense } = useLicenseDetails();
   const [unitId, setUnitId] = useState(
      license?.allocatedUnitId ? String(license.allocatedUnitId) : null
   );
   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);

   async function handleSubmit(event) {
      event.preventDefault();
      const validation = licenseAllocationSchema.safeParse({
         unitId: unitId ?? "",
      });
      if (!validation.success) {
         setErrors(getZodFieldErrors(validation.error));
         return;
      }
      setErrors({});

      setIsSubmitting(true);
      try {
         const response = await LicenseService.updateAllocation(
            license.id,
            unitId
         );
         if (response?.status >= 200 && response.status < 300) {
            const refreshedLicense = await LicenseService.getLicense(license.id);
            if (refreshedLicense?.status >= 200 && refreshedLicense.status < 300) {
               setLicense(refreshedLicense.data);
            }
            setCurrentSubTab(null);
         }
      } finally {
         setIsSubmitting(false);
      }
   }

   return (
      <div className="fade-in mt-0.5!">
         <div className="flex flex-row items-center justify-between">
            <h2 className="font-bold! text-[15px]!">
               {license?.allocatedUnitId ? "Realocar licença" : "Alocar licença"}
            </h2>
         </div>
         <p className="mt-3! opacity-60 leading-snug!">
            Selecione a unidade onde esta licença será alocada.
         </p>
         <form className="flex flex-col gap-3 mt-7!" onSubmit={handleSubmit}>
            <UnitSelector
               unitId={license?.allocatedUnitId}
               modalTitle="Selecione a unidade"
               inputLabel="Unidade *"
               parentId={unitId}
               setParentId={setUnitId}
               disabled={isSubmitting}
               error={errors.unitId}
            />
            <div className="w-full flex flex-row items-center justify-end gap-3! mt-6!">
               <Button
                  className="button-white"
                  label="Cancelar"
                  onClick={() => setCurrentSubTab(null)}
                  disabled={isSubmitting}
               />
               <Button
                  className="button-blue"
                  label="Salvar"
                  type="submit"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
               />
            </div>
         </form>
      </div>
   );
}
